module.exports = __webpack_public_path__ + "static/img/erCode.879bb5e8.png";